import React from 'react';
import { MaterialIcon } from '@dewise-devex/backstage-plugin-mui-uikit-react';

export const getCircleIcon = (type: WorkItemState) => {
  return (
    <MaterialIcon.circle
      sx={{
        stroke: theme => {
          return theme.palette.common.black;
        },
        strokeWidth: '1px',
        width: '12px',
        height: '12px',
        fill: theme => {
          const colorMap = {
            New: theme.palette.neutral.neutral80,
            'In Progress': theme.palette.tertiary.container,
            Resolved: theme.palette.extended.green.seed,
            Done: theme.palette.secondary.container,
          };
          const key = Object.keys(colorMap).find(item =>
            type.toLowerCase().includes(item.toLowerCase()),
          );

          return key ? colorMap[key as keyof object] : undefined;
        },
      }}
    />
  );
};
